import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export default function LineMonthSeries({ data = [], year }) {

  const labels = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

  const mesesMap = {
    Enero: 0, Febrero: 1, Marzo: 2, Abril: 3,
    Mayo: 4, Junio: 5, Julio: 6, Agosto: 7,
    Septiembre: 8, Octubre: 9, Noviembre: 10, Diciembre: 11
  };

  const totalsByMonth = new Array(12).fill(0);

  data.forEach(r => {
    const mes = r.mes?.charAt(0).toUpperCase() + r.mes?.slice(1).toLowerCase();
    const index = mesesMap[mes];

    if (index !== undefined) {
      totalsByMonth[index] = Number(r.total) || 0;
    }
  });

  // 🔹 Promedio mensual
  const promedio = useMemo(() => {
    const total = totalsByMonth.reduce((a, b) => a + b, 0);
    return total / 12;
  }, [totalsByMonth]);

 const chartData = {
  labels,
  datasets: [
    {
      label: `Recaudación ${year}`,
      data: totalsByMonth,
      borderColor: '#36A2EB',
      backgroundColor: 'rgba(54, 162, 235, 0.3)',
      fill: true,
      tension: 0.4,
      pointRadius: 4
    }
  ]
};

  const formatMoney = (value) =>
    new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    }).format(value);

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    interaction: {
      mode: 'index',
      intersect: false
    },

    plugins: {
      legend: {
        position: 'top'
      },
      title: {
        display: true,
        text: `Recaudación mensual ${year}`
      },
      tooltip: {
        callbacks: {
          label: (context) => formatMoney(context.raw)
        }
      }
    },

    scales: {
      y: {
        ticks: {
          callback: (value) => formatMoney(value)
        }
      }
    },

    animation: {
      duration: 800,
      easing: 'easeOutQuart'
    }
  };

  return (
    <div style={{ height: '320px', position: 'relative' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}